<template>
  <div class="list-wrapper">
    <div class="content-wrapper">
      <div class="h-full">
        <div class="c_group">
          <XzTagGroup :data="statusWithAll" :active="outform.activeStatus" @handleClick="handleStatusChange">
            <span class="title">订单状态</span>
          </XzTagGroup>
        </div>
        <div class="table-wrapper" :class="{ 'fullscreen': isFullScreen }">
          <xz-table
            ref="xzTable"
            :columns="columnsLists"
            :data="data"
            :toolsAttrs="toolsAttrs"
            :searchVal.sync="form.code"
            :searchAttrs="searchAttrs"
            :scroll="{ x: '100%', y: scrollHeight }"
            :drawerVisible.sync="drawerVisible"
            :drawerWidth="470"
            rowKey="id"
            :isNest="true"
            :expandedRowKeys.sync="expandedRowKeys"
            @openCloseAll="openCloseAll"
            @search="handleConfirmSearch"
            @refresh="handleReset"
            @fullScreen="handleFullScreen"
            @expand="expandedOneRow">
            <template #drawer>
              <div style="flex: 1; overflow: auto" class="advanced-search">
                <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <a-form-model-item label="订单编号">
                    <a-input v-model="form.code" placeholder="请输入订单编号" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item label="订单状态">
                    <a-select v-model="form.status" placeholder="请选择订单状态" allow-clear>
                      <a-select-option v-for="opt in statusWithAll" :key="opt.value" :value="opt.value">
                        {{ opt.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item v-if="isDirectlySalesCompany" label="交付状态">
                    <a-select v-model="form.status" placeholder="请选择交付状态" allow-clear>
                      <a-select-option v-for="opt in receiveStatusWithAll" :key="opt.value" :value="opt.value">
                        {{ opt.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item label="订单金额">
                    <a-input-number v-model="form.minOrderTotalAmount" placeholder="最小金额" :min="0" :step="0.01"
                      style="width: 47%;" :precision="2" />
                    ~
                    <a-input-number v-model="form.maxOrderTotalAmount" placeholder="最大金额" :min="0" :step="0.01"
                      style="width: 47%;" :precision="2" />
                  </a-form-model-item>
                  <a-form-model-item label="收款金额">
                    <a-input-number v-model="form.minSellerAmount" placeholder="最小金额" :min="0" :step="0.01" style="width: 47%;"
                      :precision="2" />
                    ~
                    <a-input-number v-model="form.maxSellerAmount" placeholder="最大金额" :min="0" :step="0.01" style="width: 47%;"
                      :precision="2" />
                  </a-form-model-item>
                  <a-form-model-item label="合同编号" allow-clear>
                    <a-input v-model="form.contractCode" placeholder="请输入合同编号" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item label="最终用户">
                    <a-input v-model="form.finalCustomerName" placeholder="请输入最终用户" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item label="创建人">
                    <a-input v-model="form.createUserName" placeholder="请输入创建人" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item label="创建时间">
                    <a-range-picker v-model="form.createDateRange" valueFormat="x" :placeholder="['开始时间', '结束时间']"
                      style="width: 100%;" show-time allow-clear>
                    </a-range-picker>
                  </a-form-model-item>
                </a-form-model>
              </div>
              <div style="text-align: right; height: 68px; line-height: 68px">
                <a-button @click="handleReset">
                  重置
                </a-button>
                <a-button type="primary" style="margin-left: 10px;" @click="handleConfirmSearch">
                  确定
                </a-button>
              </div>
            </template>
            <template #others>
              <a-radio-group v-if="!isDirectlySalesCompany" v-model="saleOrderType" buttonStyle="solid">
                <a-radio-button v-if="isJoin" :class="{ 'active-radio': saleOrderType === 'saleOrder' }" value="saleOrder">
                  加盟销售
                </a-radio-button>
                <a-radio-button :class="{ 'active-radio': saleOrderType === 'purchaseOrder' }" value="purchaseOrder">
                  直营销售
                </a-radio-button>
              </a-radio-group>
            </template>
            <template #custom>
              <tableHeaderConfiguration
                ref="tableHeaderConfigurationRef"
                :businessType="saleOrderType === 'saleOrder' ? '3' : saleOrderType === 'purchaseOrder' ? '4' : ''"
                :disabledList="disabledList"
                :baseLists="baseLists"
                @updateColumnList="updateColumnList"
              />
            </template>
            <div slot="code" slot-scope="text, record">
              <span v-if="actionPermissionMap['order:list:detail']" @click="() => handleView(record)" style="cursor: pointer;color: #409eff;">{{ text }}</span>
              <span v-else>{{ text }}</span>
            </div>
            <div slot="status" slot-scope="text, record">
              <el-tag :type="record.statusName === '执行中' ? '' : record.statusName === '已完结' ? 'success' : 'info'">{{ record.statusName }}</el-tag>
            </div>
            <div slot="action" slot-scope="_, record">
              <div v-if="record.status === 0">
                <a v-if="actionPermissionMap['order:list:cancel']" @click="handleCancel(record)">取消</a>
                <a v-if="actionPermissionMap['order:list:update']" @click="handleEdit(record)">编辑</a>
                <a v-if="actionPermissionMap['order:list:delete']" @click="handleDelete(record)">删除</a>
              </div>
              <div v-if="record.status === 3 && record.collectionStatus !== 2">
                <a v-if="actionPermissionMap['order:list:receipt']" @click="handleCollection(record)">收款</a>
              </div>
            </div>
            <xz-table
              rowKey="id"
              class="subTable"
              slot="expandedRowRender"
              slot-scope="row"
              :columns="subColumnsLists"
              :data="row.goodsList">
            </xz-table>
          </xz-table>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <a-pagination
        :current="pagination.pageNum"
        :total="total"
        :show-total="total => `共 ${total || 0} 条`"
        show-size-changer
        :pageSizeOptions="['10', '20', '30', '50', '100']"
        show-quick-jumper
        :pageSize.sync="pagination.pageSize"
        @change="handleNumChange"
        @showSizeChange="handleSizeChange"
      />
    </div>
    <a-modal v-model="visible" title="销售订单收款" :width="900" :bodyStyle="{ padding: '0 12px' }" centered @ok="handleOk"
      @cancel="visible = false;">
      <br />
      <a-descriptions bordered size="small">
        <a-descriptions-item label="核算单位">
          {{ orderInfo.accountingUnit }}
        </a-descriptions-item>
        <a-descriptions-item label="客户抬头">
          {{ orderInfo.customerHead }}
        </a-descriptions-item>
        <a-descriptions-item label="待收金额">
          {{ format(orderInfo.waitReceiptAmount) }}
        </a-descriptions-item>
      </a-descriptions>
      <a-alert v-if="isAlert" style="margin-top: 8px;" :message="warningMessage" banner closable
        @close="isAlert = false;" />
      <a-form-model ref="collection" :model="collectingForm">
        <xz-table ref="table" :columns="collectionColumns" :data="collectingForm.collectionData"
          :scroll="{ x: '100%', y: 600 }" rowKey="id">
          <span slot="amount" slot-scope="text, record, index">
            <a-form-model-item :prop="'collectionData.' + index + '.amount'" :rules="setRule(record)"
              style="margin-bottom: 0;">
              <a-input-number v-model="record.amount" placeholder="请输入结算金额" :min="0" :step="0.01" style="width: 100%;"
                :precision="2" />
            </a-form-model-item>
          </span>
          <template slot="footer" slot-scope="currentPageData">
            <div>
              <b>含税总金额（元）：</b>{{ Math.round(currentPageData.reduce((pre, cur) => pre + cur.amount, 0) * 100) /
          100 || '' }}
            </div>
          </template>
        </xz-table>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { saleOrderList, purchaseOrderList, cancelOrder, deleteSaleAndPurchOrder, tenantBaseInfo, receiptMoneyInfo, contactClaimList, saleOrderReceive } from '@/api/contract';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import XzTagGroup from '@/components/xiaozi-ui/xz-tag-group';
import * as Moment from 'dayjs';
import { mapGetters } from 'vuex';
import { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { COMMON_COLUMNS, SUB_COMMON_COLUMNS_SALE, SUB_COMMON_COLUMNS_PURCHASE } from './config/list';
import directlySaleCompanyMixin from '../mixins/directlySaleCompanyMixin';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';

const SALE_CONTRACT_STATUS_ALL = '';
const SALE_CONTRACT_STATUS_DRAFT = 0; // 草稿
const SALE_CONTRACT_STATUS_IN_PROGRESS = 3; // 执行中
const SALE_CONTRACT_STATUS_FINISHED = 5; // 已完结
const SALE_CONTRACT_STATUS_CANCELED = 4; // 已取消

const WAIT_TO_RECEIVE = 0;
const RECEIVED = 1;

const STATUS = [
  {
    label: '草稿',
    value: SALE_CONTRACT_STATUS_DRAFT,
  },
  {
    label: '执行中',
    value: SALE_CONTRACT_STATUS_IN_PROGRESS,
  },
  {
    label: '已完结',
    value: SALE_CONTRACT_STATUS_FINISHED,
  },
  {
    label: '已取消',
    value: SALE_CONTRACT_STATUS_CANCELED,
  },
];

const EXECUTION_STATUS_ARRAY_MAP = ['草稿', '审核中', '已驳回', '执行中', '已取消', '已完结'];

export default {
  name: 'SaleOrders',
  components: {
    xzTable,
    XzTagGroup,
    tableHeaderConfiguration,
  },
  mixins: [TablePaginationMixin, directlySaleCompanyMixin],
  computed: {
    ...mapGetters(['actionPermissionMap']),
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        advancedSearch: true,
        custom: true,
      };
    },
    subColumnsLists () {
      if (this.saleOrderType === 'saleOrder') {
        return [...SUB_COMMON_COLUMNS_SALE];
      }
      return [...SUB_COMMON_COLUMNS_PURCHASE];
    },
  },
  watch: {
    saleOrderType () {
      if (this.saleOrderType === 'saleOrder') {
        this.columnsLists = [
          ...COMMON_COLUMNS,
          {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            fixed: 'right',
            width: 120,
            scopedSlots: { customRender: 'action' },
          },
        ];
      } else {
        this.columnsLists = [...COMMON_COLUMNS];
      }

      this.$nextTick(() => {
        this.handleReset();
        this.$refs.tableHeaderConfigurationRef.getRuleLists();
      });
    },
  },
  data () {
    return {
      expandedRowKeys: [],
      columnsLists: [
        ...COMMON_COLUMNS,
      ],
      baseLists: [
        ...COMMON_COLUMNS,
      ],
      disabledList: ['code', 'status', 'total'],
      expandConfig: {
        accordion: true,
        lazy: false,
        expandAll: false,
        reserve: true,
      },
      drawerVisible: false,
      drawerStyle: {
        display: 'flex',
        flexDirection: 'column',
      },
      bodyStyle: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      },
      data: [],
      outform: {
        activeStatus: '',
      },
      form: {
        code: undefined,
        status: undefined,
        minOrderTotalAmount: undefined,
        maxOrderTotalAmount: undefined,
        minSellerAmount: undefined,
        maxSellerAmount: undefined,
        contractCode: undefined,
        finalCustomerName: undefined,
        createUserName: undefined,
        createDateRange: undefined,
      },
      activeStatus: '',
      total: 0,
      searchAttrs: {
        show: true,
        placeholder: '请输入订单编号',
        data: 'code',
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      statusWithAll: [
        {
          label: '全部',
          value: SALE_CONTRACT_STATUS_ALL,
        },
        ...STATUS,
      ],
      receiveStatusWithAll: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '待交付',
          value: WAIT_TO_RECEIVE,
        },
        {
          label: '已交付',
          value: RECEIVED,
        },
      ],
      saleOrderType: 'saleOrder',
      EXECUTION_STATUS_ARRAY_MAP,
      SALE_CONTRACT_STATUS_DRAFT,
      SALE_CONTRACT_STATUS_IN_PROGRESS,
      isJoin: false,
      visible: false,
      collectionColumns: [
        {
          title: '收款单号',
          dataIndex: 'settlementCode',
          key: 'settlementCode',
          width: 160,
          ellipsis: true,
        },
        {
          title: '收付日期',
          dataIndex: 'settlementDate',
          key: 'settlementDate',
          width: 160,
          ellipsis: true,
          customRender: (text) => {
            return text ? Moment(text * 1).format('YYYY-MM-DD') : '--';
          },
        },
        {
          title: '收款单金额(元)',
          dataIndex: 'settlementAmount',
          key: 'settlementAmount',
          width: 160,
          ellipsis: true,
        },
        {
          title: '收款单余额(元)',
          dataIndex: 'claimAmount',
          key: 'claimAmount	',
          width: 160,
          ellipsis: true,
        },
        {
          title: '本次结算金额(元)',
          dataIndex: 'amount',
          key: 'amount',
          width: 160,
          scopedSlots: { customRender: 'amount' },
        },
      ],
      orderInfo: {},
      collectingForm: {
        collectionData: [],
      },
      warningMessage: '',
      isAlert: false,
      scrollHeight: 'calc(100vh - 220px - 70px - 57px)',
      isFullScreen: false,
    };
  },
  methods: {
    updateColumnList (columnsLists) {
      if (this.saleOrderType === 'saleOrder') {
        this.columnsLists = [
          ...columnsLists,
          {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            fixed: 'right',
            width: 120,
            scopedSlots: { customRender: 'action' },
          },
        ];
      } else {
        this.columnsLists = [...columnsLists];
      }
      setTimeout(() => {
        this.expandedRowKeys = [];
        this.$refs.xzTable.addElementsToClass();
      }, 0);
    },
    newOrder () {
      this.$router.push({
        name: 'SALESMANAGEMENT_BILLINGORDER_NEW',
      });
    },
    mapStausName (status) {
      let name = '';
      if (this.saleOrderType === 'saleOrder') {
        name = EXECUTION_STATUS_ARRAY_MAP[status];
      } else {
        name = status === 2 ? EXECUTION_STATUS_ARRAY_MAP[status + 1] : EXECUTION_STATUS_ARRAY_MAP[status];
      }
      return name;
    },
    setPurchOrderSts (status) {
      let retSts = status;

      if (status === SALE_CONTRACT_STATUS_IN_PROGRESS) {
        retSts = 2; // 采购订单执行中状态值为2
      }

      return retSts;
    },
    format (v) {
      let ret = '--';

      if (v || v === 0) {
        ret = v.toFixed(2);
      }

      return ret;
    },
    validatePayment (rule, value, callback) {
      if ((!value && value !== 0) || (Number(value || '') > rule.claimAmount)) {
        this.warningMessage = '结算金额不能为空且结算金额不能大于收款单余额';
        this.isAlert = true;
        return callback(new Error(' '));
      }
      callback();
    },
    setRule (row) {
      return [
        { claimAmount: row.claimAmount, validator: this.validatePayment, trigger: 'blur' },
      ];
    },
    async handleCollection (record) {
      this.isAlert = false;

      let res = await receiptMoneyInfo({ id: record.id });

      this.orderInfo = {
        id: record.id,
        ...res.body,
      };

      const param = {
        contactsType: 'CUSTOMER',
        receiptPaymentTypeEnum: 'RECEIPT',
        payableId: this.orderInfo.customerId,
        payableName: this.orderInfo.customerHead,
        type: 1, // 付款认领对应采购付款接口
        accountingUnit: this.orderInfo.accountingUnit,
        accountingUnitId: this.orderInfo.accountingUnitId,
      };

      res = await contactClaimList(param);

      let waitReceiptAmount = Number(this.orderInfo.waitReceiptAmount || '');

      (res?.body || []).forEach(v => {
        v.amount = Math.min(v.claimAmount, waitReceiptAmount);

        if (v.claimAmount <= waitReceiptAmount) {
          waitReceiptAmount = waitReceiptAmount - v.claimAmount;
        } else {
          waitReceiptAmount = 0;
        }
      });

      this.collectingForm.collectionData = res?.body || [];

      this.record = record;

      this.visible = true;
    },
    handleOk () {
      this.$refs.collection.validate(async (valid) => {
        if (!valid) {
          return false;
        }

        let summary = this.collectingForm.collectionData.reduce((curr, next) => {
          return curr + Number(next.amount || '');
        }, 0);

        if (!summary || summary > this.orderInfo.waitReceiptAmount) {
          this.isAlert = true;
          this.warningMessage = '总认领金额不能为0，也不能大于待收金额';

          return false;
        }

        const itemList = [];

        this.collectingForm.collectionData.forEach(v => {
          if (Number(v.amount || '')) {
            itemList.push({
              amount: v.amount,
              settlementCode: v.settlementCode,
              settlementId: v.id,
            });
          }
        });

        const param = {
          saleOrderId: this.orderInfo.id,
          itemList,
        };

        saleOrderReceive(param).then(() => {
          this.handleSearch();
          this.visible = false;
        });
      });
    },
    handleConfirmSearch () {
      this.pagination.pageNum = 1;
      this.handleSearch();
    },
    handleReset () {
      this.activeStatus = '';

      for (const key in this.form) {
        this.form[key] = key === 'status' ? '' : undefined;
      }

      this.pagination.pageNum = 1;
      this.pagination.pageSize = 10;

      this.handleSearch();
    },
    handleSizeChange (_, size) {
      this.pagination.pageSize = size;
      this.handleSearch();
    },
    handleNumChange (num) {
      this.pagination.pageNum = num;
      this.handleSearch();
    },
    openCloseAll () {
      setTimeout(() => {
        this.expandedRowKeys.forEach((key) => {
          const elements = document.querySelectorAll(`[data-row-key='${key}-extra-row']`);
          const length = elements.length;
          const height = elements[0].offsetHeight - 18.6;
          const tableContents = elements[0].querySelectorAll('.ant-table-content');
          if (tableContents.length) {
            for (let i = 0; i < tableContents.length; i++) {
              tableContents[i].style.paddingRight = 200 + 'px';
            }
          }

          elements[length - 1].childNodes[0].innerHTML = `<div style='height: ${height}px;'></div>`;

          // 设置fixed-left时，子表格paddingRight为0
          const fixedTableLeft = document.querySelectorAll('.ant-table-fixed-left');
          if (fixedTableLeft.length) {
            const fixedRows = fixedTableLeft[0].querySelectorAll(`[data-row-key='${key}-extra-row']`);
            if (fixedRows.length) {
              const fixedRowsSecondTd = fixedRows[0].querySelectorAll('td')[1];
              if (fixedRowsSecondTd) {
                fixedRowsSecondTd.style.paddingRight = 0;
              }
            }
          }
        });
      }, 0);
    },
    expandedOneRow (_, rec) {
      setTimeout(() => {
        const elements = document.querySelectorAll(`[data-row-key='${rec.id}-extra-row']`);
        const length = elements.length;
        const height = elements[0].offsetHeight - 18.6;
        const tableContents = elements[0].querySelectorAll('.ant-table-content');

        if (tableContents.length) {
          for (let i = 0; i < tableContents.length; i++) {
            tableContents[i].style.paddingRight = 200 + 'px';
          }
        }

        elements[length - 1].childNodes[0].innerHTML = `<div style='height: ${height}px;'></div>`;

        // 设置fixed-left时，子表格paddingRight为0
        const fixedTableLeft = document.querySelectorAll('.ant-table-fixed-left');
        if (fixedTableLeft.length) {
          const fixedRows = fixedTableLeft[0].querySelectorAll(`[data-row-key='${rec.id}-extra-row']`);
          if (fixedRows.length) {
            const fixedRowsSecondTd = fixedRows[0].querySelectorAll('td')[1];
            if (fixedRowsSecondTd) {
              fixedRowsSecondTd.style.paddingRight = 0;
            }
          }
        }
      }, 0);
    },
    setValOrUndefined (v) {
      return (v === '' || v === null) ? undefined : v;
    },
    async handleSearch () {
      const api = this.saleOrderType === 'saleOrder' ? saleOrderList : purchaseOrderList;

      let params = {};

      this.activeStatus = this.form.status;

      if (this.saleOrderType === 'saleOrder') {
        params = {
          ...this.form,
          findInvoiceAmountFlag: true,
          findCollectionAmountFlag: true,
          findOrderGoodsFlag: true,
          findGoodsFlag: true,
          createTimeStart: this.form.createDateRange?.[0],
          createTimeEnd: this.form.createDateRange?.[1],
        };
      } else if (this.saleOrderType === 'purchaseOrder') {
        params = {
          orderCode: this.form.code,
          orderSts: this.setPurchOrderSts(this.form.status),
          minOrderTotalAmount: this.form.minOrderTotalAmount,
          maxOrderTotalAmount: this.form.maxOrderTotalAmount,
          minSellerAmount: this.form.minSellerAmount,
          maxSellerAmount: this.form.maxSellerAmount,
          pcCode: this.form.contractCode,
          finalCustomerName: this.form.finalCustomerName,
          createUserName: this.form.createUserName,
          beginCreateTime: this.form.createDateRange?.[0],
          endCreateTime: this.form.createDateRange?.[1],
          findDeviceFlag: true,
          findGoodsFlag: true,
        };
      }

      for (const k in params) {
        params[k] = this.setValOrUndefined(params[k]);
      }
      this.data = [];
      const { body } = await api({
        ...params,
        orderBy: [
          {
            orderByProperty: 'lastUpdateTime',
            orderByType: 'DESC',
          },
        ],
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
      });

      if (this.saleOrderType === 'saleOrder') {
        this.data = (body?.list || []).map(i => ({
          ...i,
          statusName: this.mapStausName(i.status),
          taxRate: i.taxRate ? parseInt(i.taxRate * 100) + '%' : '--',
          createTime: Moment(i.createTime * 1).format('YYYY-MM-DD HH:mm:ss'),
        }));
      } else if (this.saleOrderType === 'purchaseOrder') {
        this.data = (body?.list || []).map(v => ({
          id: v.id,
          code: v.orderCode,
          statusName: this.mapStausName(v.orderSts),
          total: v.orderTotalAmount,
          invoiceAmount: v.invoiceAmount,
          collectionAmount: v.sellerAmount,
          contractCode: v.pcCode,
          finalCustomerName: v.finalCustomerName,
          createUserName: v.createUserName,
          createTime: Moment(v.createTime * 1).format('YYYY-MM-DD HH:mm:ss'),
          customerHead: v.unit,
          goodsList: v.goodsList,
        }));
      }

      this.total = body?.total || 0;
      if (this.drawerVisible) {
        this.drawerVisible = false;
      }
      setTimeout(() => {
        this.expandedRowKeys = [];
        this.$refs.xzTable.addElementsToClass();
      }, 0);
    },
    handleView (record) {
      this.$router.push({
        name: this.saleOrderType === 'saleOrder' ? 'SALESMANAGEMENT_BILLINGORDER_SALE_DETAIL' : 'SALESMANAGEMENT_BILLINGORDER_PURCH_DETAIL',
        query: {
          id: this.$encode(record.id),
        },
      });
    },
    handleCancel (record) {
      this.$confirm('确认取消该订单吗？', '确认取消', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        cancelOrder({ id: record.id }).then(() => {
          this.handleSearch();
        });
      });
    },
    handleDelete (record) {
      this.$confirm('确认删除订单吗？', '确定删除', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteSaleAndPurchOrder({ saleOrderId: record.id }).then(() => {
          this.handleSearch();
        });
      });
    },
    handleEdit (record) {
      this.$router.push({
        name: 'SALESMANAGEMENT_BILLINGORDER_NEW',
        query: {
          id: this.$encode(record.id),
        },
      });
    },
    handleStatusChange (v) {
      this.activeStatus = v.value;
      this.form.status = v.value;

      this.pagination.pageNum = 1;

      this.handleSearch();
    },
    async getTenantBaseInfo () {
      const { body } = await tenantBaseInfo();

      // 小紫联营服务入驻状态（入驻状态（1-未入驻，2-入驻中，3-已入驻，4-已过期）,directlySaleCompanyIds判断是否上海小紫和海南小紫时
      this.isJoin = body.enteringStatus * 1 === 3 || this.directlySaleCompanyIds.includes(body?.tenantId);

      if (!this.isJoin) {
        this.saleOrderType = 'purchaseOrder';
      }

      this.handleSearch();
    },
    handleFullScreen (flag) {
      this.isFullScreen = flag;
    },
  },
  created () {
    this.getTenantBaseInfo();
  },
};
</script>
<style scoped lang="scss">
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}

.list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  .content-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 8px;

    .h-full {
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .c_group {
        position: relative;

        .content_block {
          border-bottom: 0.5px solid #DFE2E8;
          padding: 10px;
        }

        .title {
          font-size: 14px;
          font-weight: 600;
          padding-right: 2em;
        }
      }

      .table-wrapper {
        padding: 16px 12px;
        flex: 1;
        overflow: auto;

        .ant-radio-button-wrapper {
          border-width: 0;
          background-color: #f2f4f7;

          &.active-radio {
            border-color: #e2f3fe;
            background-color: #e2f3fe;
            color: #237ffa;
          }
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          width: 0;
        }
      }
    }
  }

  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #FFFFFF;
  }
}

/deep/.ant-table-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #c9ced6;
  background: #c9ced6;
}

//鼠标移入样式
/deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #c9ced6;
}

/deep/.ant-drawer-body {
  padding: 16px;
}

.text-right {
  text-align: right;
  border-top: 1px solid #dddddd;
  padding-top: 10px;
  margin-top: 6px;
}

.top {
  display: flex;
  padding: 6px 0;
  background: #FFFFFF;
  box-shadow: inset 0 -1px 0 0 #DFE2E8;
  margin-bottom: 10px;
  font-family: PingFang SC;
  font-size: 16px;
  color: #1F2733 100%;
  letter-spacing: 0px;
  opacity: 1;

  span {
    flex: 1;
    height: 24px;
    line-height: 24px;
  }

  time {
    cursor: pointer;
  }
}

.list-item {
  display: flex;
  cursor: move;
  height: 40px;
  padding: 4px 8px;

  .el-checkbox__label {
    height: 32px;
    line-height: 32px;
  }

  .labelContainer {
    flex: 1;
    height: 32px;
    line-height: 32px;
    margin-left: 10px;
  }
}

.noFixedItem {
  font-family: PingFang SC;
  font-size: 14px;
  color: #929AA6;
  letter-spacing: 0px;
  line-height: 0px;
  opacity: 1;
  height: 40px;
  line-height: 32px;
  padding: 4px 8px;
  list-style: none;
}

/deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background: rgb(35, 127, 250);
  border-color: rgb(35, 127, 250);
  opacity: 0.4;
  color: #FFFFFF;
}

.ant-table-body {
  overflow: overlay !important;
  padding-right: 16px;
  padding-bottom: 16px;
}

.ant-table-placeholder {
  border-top: 0;
}

.ant-table-body tr:last-child td {
  border-bottom: 0;
}

.ant-table-tbody tr:last-child td {
  border-bottom: 0;
}

.top {
  display: flex;
  box-shadow: none;

  .right {
    flex: 1;
    text-align: right;
  }
}

/deep/.vxe-table--render-default .vxe-table--expanded {
  display: inline-block;
  width: 17px;
  height: 17px;
  color: inherit;
  line-height: 13px;
  text-align: center;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  outline: none;
  transition: all .3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;

  &.is--active {
    border: 1px solid #5195eb;
    color: #5195eb;
  }

  .vxe-table--expand-btn.vxe-icon--arrow-right.rotate90::before {
    content: '-';
    transform: rotate(90deg);
    border: none;
    position: absolute;
    left: 9px;
    top: 5.5px;
    font-size: 12px;
    color: #5195eb;
    width: 6px;
    // border-top: 1px solid #5195eb;
    height: 1px;
  }

  .vxe-table--expand-btn.vxe-icon--arrow-right::before {
    content: '+';
    transform: rotate(0deg);
    border: none;
    position: absolute;
    left: 1px;
    top: -2px;
    font-size: 14px;
  }
}

.el-tag.el-tag--success {
  background-color: #E5FEEB;
  border-color: #e1f3d8;
  color: #14CA64;
}

.el-tag.el-tag--light {
  background-color: #E2F3FE;
  border-color: #e1f3d8;
  color: #237FFA;

  &.el-tag--info {
    background-color: #F2F4F7;
    border-color: #e1f3d8;
    color: #1F2733;
  }
}

/deep/.vxe-header--column .vxe-cell--title {
  font-family: PingFang SC;
  color: #1F2733;
  letter-spacing: 0px;
  opacity: 1;
}

/deep/ .vxe-table--render-default .vxe-cell .vxe-cell--label {
  font-family: PingFang SC;
  color: #1F2733;
  letter-spacing: 0px;
}

/deep/ .vxe-table--body-wrapper::-webkit-scrollbar {
  height: 12px;
  width: 10px;
}

/deep/ .vxe-table--body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #C9CED6;
  background: #C9CED6;
}

//鼠标移入样式
/deep/ .vxe-table--body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #C9CED6;
}

.advanced-search {
  .ant-form-item {
    margin-bottom: 8px;
  }
}
</style>
